<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">Filtre et recherche</h3>
                        <button type="button"
                                class="btn btn-xs btn-default btn-flat margin pull-right"
                                style="margin-top: 0;margin-bottom: 0;"
                                @click="resetFilter()"
                        >
                            Réinitialiser les filtres
                        </button>
                    </div>
                    <div class="box-body">
                        <div class="row">
                            <div class="col-md-2 input-daterange" id="dataRange">
                                <div class="form-group">
                                    <label>Du:</label>
                                    <div class="input-group date ">
                                        <div class="input-group-addon">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                        <input type="text" name="periodeDu" v-model="periodeDu"
                                               class="form-control pull-right datepicker" id="datepicker1">
                                    </div>
                                    <!-- /.input group -->
                                </div>
                                <div class="form-group ">
                                    <label>Au:</label>
                                    <div class="input-group date ">
                                        <div class="input-group-addon">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                        <input type="text" name="periodeAu" v-model="periodeAu"
                                               class="form-control pull-right datepicker" id="datepicker2">
                                    </div>
                                    <!-- /.input group -->
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label for="statut">Type de formation/examen</label>
                                    <select id="statut" class="form-control" name="formation[type]" v-model="typeSelectedForFilter">
                                        <option value="19">Aucun/indéterminé</option>
                                        <optgroup label="Grade">
                                            <option
                                                    v-for="type in getTypeByType('grade')"
                                                    :value="type.id"
                                            >{{type.type}}
                                            </option>
                                        </optgroup>
                                        <optgroup label="Arbitre technique">
                                            <option
                                                    v-for="type in getTypeByType('arbitre_tech')"
                                                    :value="type.id"
                                            >{{type.type}}
                                            </option>
                                        </optgroup>
                                        <optgroup label="Arbitre combat">
                                            <option
                                                    v-for="type in getTypeByType('arbitre_cbt')"
                                                    :value="type.id"
                                            >{{type.type}}
                                            </option>
                                        </optgroup>
                                        <optgroup label="Divers">
                                            <option
                                                    v-for="type in getTypeByType('divers')"
                                                    :value="type.id"
                                            >{{type.type}}
                                            </option>
                                        </optgroup>
                                        <optgroup label="ADEPS">
                                            <option
                                                    v-for="type in getTypeByType('adeps')"
                                                    :value="type.id"
                                            >{{type.type}}
                                            </option>
                                        </optgroup>
                                        <optgroup label="ABFT">
                                            <option
                                                    v-for="type in getTypeByType('abft')"
                                                    :value="type.id"
                                            >{{type.type}}
                                            </option>
                                        </optgroup>
                                        <optgroup label="ETU">
                                            <option
                                                    v-for="type in getTypeByType('ETU')"
                                                    :value="type.id"
                                            >{{type.type}}
                                            </option>
                                        </optgroup>
                                        <optgroup label="WT">
                                            <option
                                                    v-for="type in getTypeByType('WTF')"
                                                    :value="type.id"
                                            >{{type.type}}
                                            </option>
                                        </optgroup>
                                        <optgroup label="Hapkido">
                                            <option
                                                    v-for="type in getTypeByType('hpk')"
                                                    :value="type.id"
                                            >{{type.type}}
                                            </option>
                                        </optgroup>
                                        <optgroup label="Tangsoodo">
                                            <option
                                                    v-for="type in getTypeByType('tng')"
                                                    :value="type.id"
                                            >{{type.type}}
                                            </option>
                                        </optgroup>
                                        <optgroup label="Haedong">
                                            <option
                                                    v-for="type in getTypeByType('hae')"
                                                    :value="type.id"
                                            >{{type.type}}
                                            </option>
                                        </optgroup>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box-footer">
                        <input type="submit" @click.prevent="searchFormations()" value="Rechercher" class="btn btn-primary pull-right"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <b-col md="9" class="my-1">
                            <h3 class="box-title">Listing des formations/examens: {{pagination_meta.total}} résultat{{pagination_meta.total>1 ? 's':''}}</h3>
                        </b-col>
                        <b-col md="3" class="my-1">
                            <b-form-input v-model="filter" style="height: 28px;" placeholder="Rechercher..."></b-form-input>
                        </b-col>
                    </div>
                    <div class="box-body">
                        <b-table
                                id="tableListingAllFormations"
                                v-if="!loadingListingFormation && listingFormations.length>0"
                                responsive bordered striped hover
                                :items="listingFormations"
                                :fields="columnsListingFormation"
                                :per-page="pagination_meta.per_page"
                                :filter="filter"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :no-local-sorting="true"
                                :no-sort-reset="true"
                                :empty-text="'Aucun résultat'"
                                :empty-filtered-text="'Aucun résultat'"
                                foot-clone
                                show-empty
                        >
                            <template slot="actions" slot-scope="row">
                                <router-link
                                        class="btn btn-default padding2"
                                        :to="{ name: 'Formation', params: { formation_id: row.item.id }}">
                                    <i class="glyphicon glyphicon-pencil"></i>
                                </router-link>
                            </template>
                            <template slot="titre" slot-scope="row">
                                <router-link
                                        :to="{ name: 'Formation', params: { formation_id: row.item.id }}">
                                    {{row.item.titre }}
                                </router-link>
                            </template>
                            <template slot="type" slot-scope="data">
                                {{data.item.type}}
                            </template>
                            <template slot="nombre_inscrits" slot-scope="data">
                                {{data.item.nombre_inscrits}}{{data.item.nombre_inscrits>1 ? " membres inscrits" : " membre inscrit"}}
                            </template>
                            <template slot="total" slot-scope="data">
                                {{data.item.total | idFormat}}€
                            </template>
                            <template slot="formationLie" slot-scope="data">
                                <!--{{data}}-->
                                <span v-if="data.item.formationLie==null">-</span>
                                <router-link v-if="data.item.formationLie!=null"
                                             :to="{ name: 'Formation', params: { formation_id: data.item.formationLie.id }}">
                                    {{data.item.formationLie.titre }}
                                </router-link>
                            </template>
                        </b-table>
                        <b-pagination size="md"
                                      @change="changePage"
                                      :total-rows="pagination_meta.total"
                                      v-model="pagination_meta.current_page"
                                      :per-page="pagination_meta.per_page">
                        </b-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';
    import vSelect from '../../Communs/vSelect/index'
    import ListSelectClub from '../../Communs/listeSelectClub'

    require('../../../../node_modules/bootstrap-datepicker/js/bootstrap-datepicker')
    require('../../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr')

    var _ = require('underscore')
    var moment = require('moment')

    export default {
        props: {},
        data() {
            return {
                sortBy: null,
                sortDesc: null,
                filter: null,
                listingFormations: [],
                loadingListingFormation: true,
                isBusy: false,
                current_page: 1,
                periodeDu: null,
                periodeAu: null,
                typeSelectedForFilter: 0,
                reset: false,
                pagination_meta: {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    path: "",
                    per_page: 20,
                    to: 1,
                    total: 1
                },
                columnsListingFormation: [
                    {
                        label: 'Date',
                        key: 'date',
                        sortable: true,
                    },
                    {
                        label: 'Formation',
                        key: 'titre',
                        sortable: true,
                    },
                    {
                        label: 'Type',
                        key: 'type',
                        sortable: true,
                    },
                    {
                        label: 'Formation liée',
                        key: 'formationLie',
                        sortable: false,
                    },
                    {
                        label: 'Nombre d\'inscrits',
                        key: 'nombre_inscrits',
                        sortable: true,
                    },
                    {
                        label: 'Total',
                        key: 'total',
                        sortable: false,
                    },
                    {
                        label: 'Actions',
                        key: 'actions',
                    },
                ]
            }
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
                getTypesFormation: 'getTypesFormation',
            }),
        },
        mounted: function () {
            var these = this
            this.getTableListingFormation();
            this.$nextTick(function () {
                $('.input-daterange').datepicker({
                    autoclose: true,
                    language: 'fr',
                    orientation:'bottom'
                }).on("changeDate", function (e) {
                    these.periodeDu = $('#datepicker1').val()
                    these.periodeAu = $('#datepicker2').val()
                });
            })
        },
        created() {
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                // vm.getTableListingFormation();
                // vm.loadStatutsFormations()
            })
        },
        watch: {
            'sortBy': function (val) {
                this.getTableListingFormation()
            },
            'sortDesc': function (val) {
                this.getTableListingFormation()
            },
            'periodeDu': function (val) {
                this.constructSearchRequest()
            },
            'periodeAu': function (val) {
                this.constructSearchRequest()
            },
            'typeSelectedForFilter': function (val) {
                this.constructSearchRequest()
            },

        },
        components: {
            vSelect,
            ListSelectClub,
        },
        methods: {
            ...mapActions({
                setStatusFormation: 'setStatusFormation',
            }),
            getTypeByType: function (typeSearched) {
                let retour = [];
                this.getTypesFormation.forEach(function (item) {
                    if (item.meta == typeSearched)
                        retour.push(item);
                });
                return _.sortBy(retour, function (item) {
                    return item.order;
                });
            },
            searchFormations: function () {
                this.sortDesc = null;
                this.sortBy = null;
                this.getTableListingFormation();
            },
            resetFilter: function () {
                this.typeSelectedForFilter = null;
                this.periodeDu = null;
                this.periodeAu = null;
                this.reset = !this.reset;
            },
            constructSearchRequest: function () {
                var objectTemp = {}
                if (this.periodeDu != '' && this.periodeDu != null)
                    objectTemp.periodeDu = this.periodeDu
                if (this.periodeAu != '' && this.periodeAu != null)
                    objectTemp.periodeAu = this.periodeAu
                if (this.typeSelectedForFilter != '' && this.typeSelectedForFilter > 0 && this.typeSelectedForFilter != null)
                    objectTemp.typeSelectedForFilter = this.typeSelectedForFilter


                if (this.pagination_meta.per_page != 0 && this.pagination_meta.per_page != null)
                    objectTemp.perPage = this.pagination_meta.per_page
                if (this.sortBy != null) {
                    let sortDesc = this.sortDesc != null ? this.sortDesc == true ? "asc" : "desc" : "desc"
                    objectTemp.sort = this.sortBy + "|" + sortDesc
                }
                if (this.pagination_meta.current_page != 0 && this.pagination_meta.current_page != null)
                    objectTemp.currentPage = this.pagination_meta.current_page

                return (objectTemp);
            },
            changePage: function (e) {
                this.pagination_meta.current_page = e
                this.getTableListingFormation();
            },
            updateTypeSelected: function (value) {
                this.typeSelectedForFilter = value.id;
            },
            currentYear: function () {
                return moment().year();
            },
            getTableListingFormation: function () {
                this.loadingListingFormation = true;
                this.isBusy = true
                let self = this
                // debugger;
                this.$http.post(self.getRoute('Secretariat.formation.getAll'), this.constructSearchRequest())
                    .then((response) => {
                        self.listingFormations = response.body.data
                        self.pagination_meta = response.body.meta
                        self.loadingListingFormation = false;
                        self.$root.$emit('bv::refresh::table', 'tableListingAllFormations');
                        // self.$refs.tableListingAllFormations.refresh();
                        // self.isBusy = false
                        // return response.body.data;
                    }, (response) => {
                        self.listingFormations = []
                        self.$root.$emit('bv::refresh::table', 'tableListingAllFormations');
                        // debugger;
                        // self.$refs.tableListingAllFormations.refresh();

                        // self.isBusy = false
                        // return []
                    });
                // return null
            },
            isTableListingFormationLoading: function (force = false) {
                if (force)
                    return true
                return this.loadingListingFormation;
            },
            console: function (event) {
                console.log(event);
            },
            formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
                if (value == null) return ''
                return moment(value, fmtIn).format(fmtOut)
            },
        },
        filters: {
            idFormat: function (value) {
                return new Intl.NumberFormat("de-DE").format(value)
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/components/Secretariat/Formation/ListingFormation.vue